export const PAUSE_PLAYER_EVENT = 'PAUSE_PLAYER_EVENT';

export default function pausePlayer() {
  window.dispatchEvent(new Event(PAUSE_PLAYER_EVENT));
}
